<template>
  <div>
    <v-row>
      <v-col md="4" cols="12">
        <v-card
          class="mb-4 py-3 d-flex align-items-center justify-content-center"
        >
          <div
            class="d-inline-block profile-image-wrapper mx-auto"
            style="position: relative"
          >
            <v-avatar size="128">
              <img v-if="file != ''" :src="getURL()" />
              <img v-else-if="group.image" :src="group.image" />
              <img v-else src="/images/default-profile.jpg" />
            </v-avatar>
            <div
              style="
                position: absolute;
                width: 25px;
                height: 25px;
                bottom: 5px;
                right: 5px;
                font-size: 12px;
                border-radius: 50%;
                border: 2px solid black;
                cursor: pointer;
              "
              class="red white--text d-flex align-center justify-center"
              @click="() => this.$refs.FileInput.click()"
              v-if="authUser && group.owner_id == authUser.id"
            >
              <input
                type="file"
                ref="FileInput"
                style="display: none"
                @change="onFilePicked"
              />
              <i class="fa fa-camera"></i>
            </div>
            <div v-if="file != ''">
              <div
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  height: 100%;
                  width: 100%;
                  border-radius: 50%;
                  background: rgba(0, 0, 0, 0.05);
                "
                class="d-flex align-center justify-center"
              >
                <div v-if="loading">
                  <v-progress-circular indeterminate />
                </div>

                <div
                  style="
                    width: 25px;
                    height: 25px;
                    font-size: 12px;
                    border-radius: 50%;
                    border: 2px solid black;
                    cursor: pointer;
                  "
                  v-if="!loading"
                  class="
                    success
                    mr-4
                    white--text
                    d-flex
                    align-center
                    justify-center
                  "
                  @click="(e) => lc_updateGroupImage(e, group.id)"
                >
                  <i class="fa fa-check"></i>
                </div>
                <div
                  style="
                    width: 25px;
                    height: 25px;
                    font-size: 12px;
                    border-radius: 50%;
                    border: 2px solid black;
                    cursor: pointer;
                  "
                  v-if="!loading"
                  @click="file = ''"
                  class="red white--text d-flex align-center justify-center"
                >
                  <i class="fa fa-trash"></i>
                </div>
              </div>
            </div>
          </div>
        </v-card>
        <v-card>
          <div
            v-if="Object.keys(group).length == 0 && groupLoading"
            class="d-flex align-items-center justify-center py-4"
          >
            <v-progress-circular indeterminate />
          </div>
          <div v-else class="pa-4 text-center">
            <h3>{{ group.name }}</h3>
            <small class="mt-3">{{ group.description }}</small>
          </div>
        </v-card>
        <v-card v-if="group.owner_id == authUser.id">
          <div class="mt-4 pa-4">
            <h4>Join Requests</h4>
            <hr />
            <div v-for="request of group.requests" :key="request.id">
              <div class="d-flex align-center mt-2">
                <v-avatar v-if="request.profile_image" class="mr-3">
                  <img :src="request.profile_image" />
                </v-avatar>
                <v-avatar v-else class="mr-3"
                  ><img src="/images/default-profile.jpg"
                /></v-avatar>
                <h4 class="ml-3">{{ request.name }}</h4>
                <div class="ml-auto">
                  <v-btn
                    icon
                    class="green white--text"
                    @click="
                      () =>
                        acceptGroupRequest({
                          owner_id: group.owner_id,
                          request_id: request.id,
                          group_id: group.id,
                          user_id: request.by,
                        })
                    "
                    ><i class="fa fa-check"></i
                  ></v-btn>
                  <v-btn
                    icon
                    class="red ml-1 white--text"
                    @click="
                      () =>
                        rejectGroupRequest({
                          request_id: request.id,
                          group_id: group.id,
                        })
                    "
                    ><i class="fa fa-trash"></i
                  ></v-btn>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col md="8" cols="12">
        <AddPost
          :handleSubmit="
            (data) => {
              addGroupPost({
                ...data,
                group_id: $router.currentRoute.params.id,
              });
            }
          "
          :loading="groupLoading"
          :notification="groupNotification"
        />
        <div class="mt-4"></div>
        <div v-if="groupLoading">
          <v-card class="pa-6 text-center"
            ><v-progress-circular indeterminate
          /></v-card>
        </div>
        <div v-else>
          <div v-for="item of groupPosts" :key="item.id">
            <Post
              :item="item"
              :addComment="
                (data) => addGroupPostComment({ ...data, group_id: group.id })
              "
              :addLike="
                (data) => addGroupPostLike({ ...data, group_id: group.id })
              "
            />
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AddPost from "../components/AddPost.vue";
import Post from "../components/Post.vue";
export default {
  name: "GroupDetail",
  data() {
    return {
      file: "",
      loading: false,
    };
  },
  components: {
    AddPost,
    Post,
  },
  async mounted() {
    let id = this.$router.currentRoute.params.id;

    await this.getGroup(id);
    await this.getGroupPosts(id);
  },
  methods: {
    onFilePicked(e) {
      this.file = e.target.files[0];
    },
    getURL() {
      return URL.createObjectURL(this.file);
    },
    async lc_updateGroupImage(e, group_id) {
      e.preventDefault();
      this.loading = true;
      await this.updateGroupImage({ id: group_id, image: this.file });
      this.loading = false;
      this.file = "";
    },
  },
};
</script>

<style scoped>
</style>